import { RadioGroup } from "@headlessui/react";
import classNames from "classnames";

export interface RadioCardProps {
  children: React.ReactNode;
  className?: string;
  value: string | number;
}

export const RadioCard = ({
  children,
  value,
  className = "",
}: RadioCardProps) => (
  <RadioGroup.Option
    value={value}
    className={({ checked }) =>
      classNames(
        "bg-primary hover:border-secondary relative flex cursor-pointer rounded-lg border p-6 shadow-sm transition-colors focus:outline-none",
        {
          "border-secondary": checked,
          "border-primary": !checked,
        },
        className,
      )
    }
  >
    {({ checked }) => (
      <>
        <span className="flex flex-1">
          <span className="flex flex-col">{children}</span>
        </span>
        <span
          className={classNames(
            "mt-1.5 flex size-4 shrink-0 items-center justify-center rounded-full border border-transparent",
            {
              "bg-toggle-active": checked,
              "bg-primary": !checked,
            },
          )}
          aria-hidden="true"
        >
          <span className="bg-primary size-1.5 rounded-full" />
        </span>
      </>
    )}
  </RadioGroup.Option>
);
